
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  projectsNewHeadline: {
    id: "projectsNewHeadline.headline",
    defaultMessage: "Create a new project",
  }, 
  projectsOverviewHeadline: {
    id: "projectsOverviewHeadline.headline",
    defaultMessage: "Addresses Building Projects",
  }, 
});

export default MESSAGES;